import { Stack, useTheme } from "@mui/material";
import { Button, Typography } from "@foodpilot/foods";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "src/utils/useSnackbar";

type AuditLogCopyFieldProps = {
    value: string | null;
    absentLabel: string;
};

export const AuditLogCopyField = (props: AuditLogCopyFieldProps) => {
    const { value, absentLabel } = props;
    const theme = useTheme();
    const { t } = useTranslation();
    const { setSnackbarProps } = useSnackbar();

    const copy = async () => {
        if (value === null) {
            return;
        }

        try {
            await navigator.clipboard.writeText(value);
            setSnackbarProps({ message: t("settings.audit_log.copied", "Copied"), type: "success" });
        } catch {
            setSnackbarProps({
                message: t("settings.audit_log.copy_failed", "Copying is not available in this browser"),
                type: "error",
            });
        }
    };

    if (value === null) {
        return (
            <Typography variant="small-regular" color="text.secondary">
                {absentLabel}
            </Typography>
        );
    }

    return (
        <Stack direction="row" alignItems="baseline" gap={theme.spacing(1)}>
            <Typography variant="body-medium" sx={{ wordBreak: "break-all" }}>
                {value}
            </Typography>
            <Button
                variant="text"
                size="small"
                onClick={() => void copy()}
                sx={{ flexShrink: 0, minWidth: "auto", paddingX: theme.spacing(0.5) }}
            >
                {t("settings.audit_log.copy", "Copy")}
            </Button>
        </Stack>
    );
};
